export function truncateText(text: string, maxWidth: number): string {
    if (!text || maxWidth <= 0) return text

    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')
    if (!context) return text

    context.font = 'normal 12px sans-serif'

    let truncated = text
    while (
        context.measureText(truncated + '...').width > maxWidth &&
        truncated.length > 0
    ) {
        truncated = truncated.slice(0, -1)
    }

    return truncated.length < text.length ? truncated + '...' : text
}